import { render, staticRenderFns } from "./LordOfApplesPage.vue?vue&type=template&id=1c4fe991&scoped=true"
import script from "./LordOfApplesPage.vue?vue&type=script&lang=ts"
export * from "./LordOfApplesPage.vue?vue&type=script&lang=ts"
import style0 from "./LordOfApplesPage.vue?vue&type=style&index=0&id=1c4fe991&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c4fe991",
  null
  
)

export default component.exports